module.exports = __webpack_public_path__ + "static/media/fac7.78c0a538.jpg";